import React, { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Button from 'components/element/Button';
import api from 'lib/api';

const FollowButton = ({ username, initialIsFollowing }) => {
  const [isFollowing, setIsFollowing] = useState(initialIsFollowing);
  const queryClient = useQueryClient();

  useEffect(() => {
    setIsFollowing(initialIsFollowing);
  }, [initialIsFollowing]);

  const toggleFollowMutation = useMutation({
    mutationFn: () => api.user.toggleFollow(username),
    onMutate: () => {
      setIsFollowing(prev => !prev);
      return { previousFollowState: isFollowing };
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['profile', username]);
      queryClient.invalidateQueries(['followers']);
    },
    onError: (error, variables, context) => {
      setIsFollowing(context.previousFollowState);
    },
  });

  return (
    <Button onClick={toggleFollowMutation.mutate} isLoading={toggleFollowMutation.isPending} disabled={toggleFollowMutation.isPending} className={`w-[6.5rem] h-10 border border-gray-less hover:border-gray-mid
      ${isFollowing
        ? 'text-gray-strongest bg-gray-weak hover:bg-gray-less'
        : 'text-gray-weakest bg-gray-strongest hover:bg-gray-strong'}
    `}>
      {isFollowing ? 'Unfollow' : 'Follow'}
    </Button>
  );
};

export default FollowButton;
